import { gql } from "@apollo/client";
export const CREATE_SPECIAL_OFFER = gql`
  mutation CreateSpecialOffer($input:CreateSpecialOfferInput) {
    createSpecialOffer( input:$input) {
        data {
            special_offer {
                updated_at
                start_date
                end_date
                status
                title
                description
                id
                created_at
                membership_duration_id
                number_of_days
                membership_duration {
                    created_at
                    price
                    number_of_days
                    description
                    package_id
                    updated_at
                    id
                    price_usd
                    duration_type
                    package {
                        package_order
                        name
                        description
                        created_at
                        package_type
                        information
                        updated_at
                        user_limit
                        id
                    }
                }
            }
        }
        error {
            message
            code
            field
        }
    }
}
`;

export const UPDATE_SPECIAL_OFFER = gql`
  mutation UpdateSpecialOffer($input:CreateSpecialOfferInput, $special_offer_id:UUID! ) {
    updateSpecialOffer(input:$input,  special_offer_id: $special_offer_id ) {
        data {
            special_offer {
                end_date
                updated_at
                start_date
                membership_duration_id
                number_of_days
                status
                title
                description
                id
                created_at
                membership_duration {
                    created_at
                    price
                    number_of_days
                    duration_type
                    description
                    package_id
                    updated_at
                    id
                    price_usd
                    package {
                        created_at
                        package_order
                        name
                        description
                        user_limit
                        id
                        package_type
                        information
                        updated_at
                    }
                }
            }
        }
        error {
            code
            field
            message
        }
    }
}
`;


export const DELETE_FEATURED_ADS = gql`
  mutation DeleteFeaturedAd($ad_id: UUID!) {
    deleteFeaturedAd(ad_id: $ad_id) {
      data {
        message
      }
      error {
        code
        field
        message
      }
    }
  }
`;
